import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasAdminSession } from "@/features/auth/session/adminSessionEmail";
import { AdminSessionManager } from "./AdminSessionManager";

export function RequireAdminSession() {
  const location = useLocation();

  if (!hasAdminSession()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname, sessionExpired: false }}
      />
    );
  }

  return (
    <>
      <AdminSessionManager />
      <Outlet />
    </>
  );
}
